import { StoreLandingLayout } from "@unauthenticated/signupSignin/components";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";

import { RxSignInModalMain } from "./PatientRxSignInModal";

interface Props {
  patientAttributes: PatientAttributes;
  additionalAttributes?: any;
  ssoErrors?: string;
  storeId?: string;
}

const PatientRxSignInPage = ({
  patientAttributes,
  additionalAttributes,
  ssoErrors,
  storeId,
}: Props) => (
  <StoreLandingLayout
    pracName={patientAttributes.pracName}
    pracAvatar={patientAttributes.pracAvatar}
  >
    <RxSignInModalMain
      patientAttributes={patientAttributes}
      additionalAttributes={additionalAttributes}
      ssoErrors={ssoErrors}
      storeId={storeId}
    />
  </StoreLandingLayout>
);

export { PatientRxSignInPage };
